import type { QueryClientProviderProps } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// import type { AuthProviderProps } from './auth-context';
// import { AuthProvider } from './auth-context';
import { LocaleProvider } from './locale-context';

export type AppProviderProps = {
  children: React.ReactNode;
  query: Omit<QueryClientProviderProps, 'children'>;
  // auth: Omit<AuthProviderProps, 'children'>;
};

export const AppProvider = ({ children, query }: AppProviderProps) => (
  <QueryClientProvider {...query}>
    {/* <AuthProvider {...auth}> */}
    <LocaleProvider>{children}</LocaleProvider>
    {/* </AuthProvider> */}
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
